import api from "./api";
import { ResponseInterface } from "../interfaces";
import { R4BankInstantTransactionResponse } from "../interfaces/R4BankInterface";
import { formatDefaultResponseErrors } from "../utils";

const baseURL = `${process.env.REACT_APP_API_HOST}/R4Bank`;

export const r4GetOTP = async (
  bank: string,
  amount: number,
  phone: string,
  ci: string
): Promise<ResponseInterface<boolean>> => {
  const stringNumber = amount.toString();
  const body = {
    Banco: bank,
    Monto: stringNumber,
    Telefono: phone,
    Cedula: ci,
  };
  try {
    const response = await api.post(`${baseURL}/GenerateOTP`, body);
    if (response?.status === 200) {
      return response.data;
    }
    return {
      didError: true,
      message: "",
      errorMessage: "No response from server: " + response.statusText,
      model: false,
    };
  } catch (error) {
    console.error("Error getting Client Key:", error);
    const errors = ((error as any)?.response?.data?.errors || []) as any[];
    const concatenated = formatDefaultResponseErrors(errors);
    return {
      didError: true,
      message: "",
      errorMessage:
        concatenated === ""
          ? "Error getting Client Key: " + String(error)
          : concatenated,
      model: false,
    };
  }
};

export const r4InstantDebit = async (
  bank: string,
  amount: number,
  phone: string,
  ci: string,
  otp: string,
  name: string,
  concept: string
): Promise<ResponseInterface<R4BankInstantTransactionResponse>> => {
  const stringNumber = amount.toString();
  const cleanName = name.replaceAll(/[^a-zA-Z ]/g, "");
  const body = {
    Banco: bank,
    Monto: stringNumber,
    Telefono: phone,
    Cedula: ci,
    OTP: otp.trim(),
    Nombre: cleanName.trim(),
    Concepto: concept.trim(),
  };

  try {
    const response = await api.post(`${baseURL}/InstantDebit`, body);
    if (response?.status === 200) {
      return response.data;
    }
    return {
      didError: true,
      message: "",
      errorMessage: "No response from server: " + response.statusText,
      model: null,
    };
  } catch (error) {
    console.error("Error processing instant debit:", error);
    const errors = ((error as any)?.response?.data?.errors || []) as any[];
    const concatenated = formatDefaultResponseErrors(errors);
    return {
      didError: true,
      message: "",
      errorMessage:
        concatenated === ""
          ? "Error processing instant debit: " + String(error)
          : concatenated,
      model: null,
    };
  }
};

export const r4InstantCredit = async (
  bank: string,
  amount: number,
  phone: string,
  ci: string,
  concept: string
): Promise<ResponseInterface<R4BankInstantTransactionResponse>> => {
  const stringNumber = amount.toString();
  const body = {
    Banco: bank,
    Monto: stringNumber,
    Telefono: phone,
    Cedula: ci,
    Concepto: concept.trim(),
  };

  try {
    const response = await api.post(`${baseURL}/InstantCredit`, body);
    if (response?.status === 200) {
      return response.data;
    }
    return {
      didError: true,
      message: "",
      errorMessage: "No response from server: " + response.statusText,
      model: null,
    };
  } catch (error) {
    console.error("Error processing instant credit:", error);
    const errors = ((error as any)?.response?.data?.errors || []) as any[];
    const concatenated = formatDefaultResponseErrors(errors);
    return {
      didError: true,
      message: "",
      errorMessage:
        concatenated === ""
          ? "Error processing instant credit: " + String(error)
          : concatenated,
      model: null,
    };
  }
};

export const r4InstantCreditAccount = async (
  amount: number,
  ci: string,
  accountNumber: string,
  concept: string
): Promise<ResponseInterface<R4BankInstantTransactionResponse>> => {
  const stringNumber = amount.toString();
  const body = {
    Monto: stringNumber.trim(),
    Cedula: ci.trim(),
    Cuenta: accountNumber.trim(),
    Concepto: concept.trim(),
  };

  try {
    const response = await api.post(`${baseURL}/InstantCreditAccount`, body);
    if (response?.status === 200) {
      return response.data;
    }
    return {
      didError: true,
      message: "",
      errorMessage: "No response from server: " + response.statusText,
      model: null,
    };
  } catch (error) {
    console.error("Error processing instant credit:", error);
    const errors = ((error as any)?.response?.data?.errors || []) as any[];
    const concatenated = formatDefaultResponseErrors(errors);
    return {
      didError: true,
      message: "",
      errorMessage:
        concatenated === ""
          ? "Error processing instant credit: " + String(error)
          : concatenated,
      model: null,
    };
  }
};